import React from 'react'
import { IconEye, IconLock, IconShield } from '@tabler/icons-react'

export default function ComplianceSection() {
  const complianceItems = [
    {
      icon: IconShield,
      title: '合法数据来源',
      points: [
        '数据来自依法公开的信息渠道及合规合作方',
        '严格用于合法合规的风险评估与背景核查场景',
        '不提供任何形式的放贷、下款、催收、资金撮合等服务',
      ],
    },
    {
      icon: IconEye,
      title: '授权在先、查询有据可查',
      points: [
        '使用单位需依法取得被查询对象授权',
        '每一次查询都会留下记录：谁查的、查了什么、什么时候查',
        '支持导出审计记录，为内部监督和外部检查提供依据',
      ],
    },
    {
      icon: IconLock,
      title: '数据安全与隐私保护',
      points: [
        '严格控制访问权限，不同账号查看的信息范围可单独配置',
        '重要数据在传输和存储中采用加密与脱敏处理',
        '定期开展安全检查，逐步提升整体防护能力',
      ],
    },
  ]

  return (
    <section className="py-32 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-20 left-20 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl animate-[floatSlow_10s_ease-in-out_infinite]"></div>
        <div className="absolute bottom-20 right-20 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl animate-[floatSlow_12s_ease-in-out_infinite_reverse]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
            合法、合规、可追溯
            <br />
            <span className="text-gray-400 text-3xl md:text-4xl">是优查查的底线</span>
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            在用好数据的前提下，守住合规和隐私底线，比什么都重要
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {complianceItems.map((item, index) => (
            <div
              key={index}
              className="group relative bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-white/10 hover:bg-white/10 hover:border-orange-500/30 transition-all duration-500"
            >
              <div className="mb-6">
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-orange-500/20 to-orange-600/20 flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-orange-500/20">
                  <item.icon size={32} className="text-orange-400" />
                </div>
              </div>

              <h3 className="text-xl font-bold text-white mb-4">{item.title}</h3>

              <ul className="space-y-3">
                {item.points.map((point, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-sm text-gray-300 leading-relaxed">
                    <span className="text-orange-400 mt-1">·</span>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-white/10">
          <p className="text-sm text-gray-300 leading-relaxed">
            <span className="text-white font-semibold">提示：</span>
            优查查愿意与合作机构一起，共同建立负责任的数据使用规范，让风控能力成为业务发展的「护栏」，而不是风险源。
          </p>
        </div>
      </div>
    </section>
  )
}
